export default {
    hello: 'Hello, world!',
    locale: {
        en: 'English',
        zh: '中文'
    },
    topNav: {
        userCenter: 'User Center',
        msgCenter: 'Message Center',
        login: 'Login',
        logout: 'Logout',
    },
    login: {
        username: 'username',
        usernamePlaceholder: 'username',
        password: 'Password',
        passwordPlaceholder: 'Password',
        login: 'Login'
    },
    link: {
        home: 'home'
    }
};


// WEBPACK FOOTER //
// ./src/locale/lang/en.js